<template>
    <div v-if="!disableEdit">
        <v-radio-group
                v-model="formData.guildRegistered"
                :error-messages="guildRegisteredErrors"
                @input="$v.formData.guildRegistered.$touch()"
                @blur="$v.formData.guildRegistered.$touch()"
        >
            <div slot="label">Guild member?</div>
            <v-radio label="Yes" value="yes"></v-radio>
            <v-radio label="No" value="no"></v-radio>
        </v-radio-group>
        <v-text-field
                v-model="formData.guildMembershipNumber"
                label="Guild Membership Number"
                :required="guildMembershipNumberRequired"
                :error-messages="guildMembershipNumberErrors"
                @input="$v.formData.guildMembershipNumber.$touch()"
                @blur="$v.formData.guildMembershipNumber.$touch()"
        ></v-text-field>
        <v-text-field
                v-model="formData.expires"
                type="date"
                label="Expires"
                :error-messages="expiresErrors"
                @input="$v.formData.expires.$touch()"
                @blur="$v.formData.expires.$touch()"
        ></v-text-field>
        <v-text-field
                v-model="formData.notes"
                label="Notes"
                :error-messages="notesErrors"
                @input="$v.formData.notes.$touch()"
                @blur="$v.formData.notes.$touch()"
        ></v-text-field>
        <v-text-field
                v-model="formData.memberType"
                label="Member Type"
                :error-messages="memberTypeErrors"
                @input="$v.formData.memberType.$touch()"
                @blur="$v.formData.memberType.$touch()"
        ></v-text-field>
        <v-checkbox
                v-model="formData.verified"
                label="Verified?"
                :error-messages="verifiedErrors"
                @input="$v.formData.verified.$touch()"
                @blur="$v.formData.verified.$touch()"
        ></v-checkbox>
    </div>
    <p v-else>Your membership details have been verified by the Guild of Fine food and cannot be changed.</p>
</template>

<script>
  import {FieldsMixin} from '@/forms/mixins'
  import {required, requiredIf} from 'vuelidate/lib/validators'

  const re = new RegExp('^[a-zA-Z]{1}\\d{7}$|^[a-zA-Z]{2}\\d{4}$|^[a-zA-Z]{2}\\d{3}$')
  export default {
    name: 'AdminGuildMembershipFields',
    mixins: [FieldsMixin],
    data: () => ({
      formData: {
        guildRegistered: null,
        guildMembershipNumber: null,
        expires: null,
        notes: null,
        memberType: null,
        verified: false,
      }
    }),
    validations: {
      formData: {
        guildRegistered: {
          required
        },
        guildMembershipNumber: {
          required: requiredIf(function () {
            return this.formData.hasOwnProperty('guildRegistered') && this.formData.guildRegistered === 'yes'
          }),
          validMembershipNumber: function (value) {
            if (typeof value === 'undefined' || value === null || value === '') {
              return true
            }
            return re.test(value)
          }
        },
        expires: {},
        notes: {},
        memberType: {},
        verified: {},
      }
    },
    computed: {
      guildMembershipNumberRequired () {
        return this.formData.hasOwnProperty('guildRegistered') && this.formData.guildRegistered === 'yes'
      },
      guildRegisteredErrors () {
        const errors = []
        if (!this.$v.formData.guildRegistered.$dirty) return errors
        !this.$v.formData.guildRegistered.required && errors.push('Please specify whether you a Guild of Fine food member.')
        return errors
      },
      guildMembershipNumberErrors () {
        const errors = []
        if (!this.$v.formData.guildMembershipNumber.$dirty) return errors
        !this.$v.formData.guildMembershipNumber.required && errors.push('Guild membership number is required if you are a Guild member.')
        !this.$v.formData.guildMembershipNumber.validMembershipNumber && errors.push('Invalid Guild membership number.')
        return errors
      },
      expiresErrors () {
        const errors = []
        if (!this.$v.formData.expires.$dirty) return errors
        return errors
      },
      notesErrors () {
        const errors = []
        if (!this.$v.formData.notes.$dirty) return errors
        return errors
      },
      memberTypeErrors () {
        const errors = []
        if (!this.$v.formData.memberType.$dirty) return errors
        return errors
      },
      verifiedErrors () {
        const errors = []
        if (!this.$v.formData.verified.$dirty) return errors
        return errors
      }
    },
    methods: {
      prepareInitialValue () {
        const validChoices = ['yes', 'no']
        // This method only gets called if there is an initial value passed, so we simply check if the registered value is set
        if (validChoices.indexOf(this.formData.guildRegistered) === -1) {
          if (this.formData.guildMembershipNumber) {
            this.formData.guildRegistered = 'yes'
          } else {
            this.formData.guildRegistered = 'no'
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
